import React, { useState, useRef, useLayoutEffect } from 'react';
import { makeStyles, Box } from '@material-ui/core';

//icons
import NextIcon from '@material-ui/icons/NavigateNext';
import PrevIcon from '@material-ui/icons/NavigateBefore';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        height: '100%',
        width: '100%',
    },
    nextArrowBox: {
        backgroundColor: '#FFF',
        height: '100%',
        width: 70,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        right: 0,
        top: 0,

        opacity: 0,
        animation: `$loadIn 300ms ${theme.transitions.easing.easeInOut}`,
        animationFillMode: 'forwards',
    },
    prevArrowBox: {
        backgroundColor: '#FFF',
        height: '100%',
        width: 70,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        left: 0,
        top: 0,

        opacity: 0,
        animation: `$loadIn 300ms ${theme.transitions.easing.easeInOut}`,
        animationFillMode: 'forwards',
    },
    arrow: {
        backgroundColor: 'rgba(51, 51, 102, 0.6)',
        color: '#FFF',
        width: 30,
        height: 30,
        cursor: 'pointer',

        '&:hover': {
            opacity: 0.5,
        },
    },
    scrollBox: {
        overflow: 'scroll',
        width: '100%',
        height: '100%',
        position: 'absolute',
        display: 'flex',
        top: 0,
        left: 0,

        '-ms-overflow-style': 'none',
        'scrollbar-color': 'transparent transparent',

        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '& ::-moz-scrollbar': {
            display: 'none',
        },
    },
    scrollInnerBox: {
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        left: 0,
        top: 0,
        paddingRight: 70,
    },

    '@keyframes loadIn': {
        '0%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
}));

const ScrollBox = ({ children, childWidth }) => {
    const classes = useStyles();
    const [showNextArrow, setShowNextArrow] = useState(false);
    const [showPrevArrow, setShowPrevArrow] = useState(false);
    const ScrollBoxElement = useRef();

    useLayoutEffect(() => {
        if (ScrollBoxElement.current) {
            if (ScrollBoxElement.current.clientWidth < ScrollBoxElement.current.scrollWidth) {
                setShowNextArrow(true);
            }
        }
    }, [ScrollBoxElement]);

    const handleNextClick = () => {
        const nextIndex = Math.floor(ScrollBoxElement.current.scrollLeft / childWidth) + 1;
        ScrollBoxElement.current.scroll({
            top: 0,
            left: nextIndex * childWidth,
            behavior: 'smooth',
        });
    };

    const handlePrevClick = () => {
        const prevIndex = Math.floor(ScrollBoxElement.current.scrollLeft / childWidth) - 1;

        ScrollBoxElement.current.scroll({
            top: 0,
            left: prevIndex * childWidth,
            behavior: 'smooth',
        });
    };

    const hadleOnScroll = (event) => {
        if (!showPrevArrow && event.target.scrollLeft >= childWidth) {
            setShowPrevArrow(true);
        } else if (showPrevArrow && event.target.scrollLeft < childWidth) {
            setShowPrevArrow(false);
        }

        if (
            showNextArrow &&
            event.target.scrollLeft === event.target.scrollWidth - event.target.clientWidth
        ) {
            setShowNextArrow(false);
        } else if (
            !showNextArrow &&
            event.target.scrollLeft !== event.target.scrollWidth - event.target.clientWidth
        ) {
            setShowNextArrow(true);
        }
    };

    return (
        <Box className={classes.root}>
            {/* {showPrevArrow && (
                <Box className={classes.prevArrowBox}>
                    <PrevIcon className={classes.arrow} onClick={handlePrevClick} />
                </Box>
            )}
            {showNextArrow && (
                <Box className={classes.nextArrowBox}>
                    <NextIcon className={classes.arrow} onClick={handleNextClick} />
                </Box>
            )} */}
            <Box className={classes.scrollBox} ref={ScrollBoxElement} onScroll={hadleOnScroll}>
                <Box className={classes.scrollInnerBox}>{children}</Box>
            </Box>
        </Box>
    );
};

ScrollBox.defaultProps = {
    children: <></>,
    childWidth: 0,
};

export default ScrollBox;
